/* MONT DEGRÉS v1 — boîte d'achat (01/11/2026, maquette finale validée par Kilian) : panneau du bas réutilisable et ligne des paliers. Vanilla, sans dépendance.
   Panneau : [data-md-sheet="clé"] ouvre #md-sheet avec le gabarit #md-sh-clé. <dialog> natif (fond inerte), focus sur la croix, Tab bouclé, Échap, appui dehors,
   glissé vers le bas sur la poignée ; focus rendu au bouton d'origine ; 240 ms, aucune animation si mouvement réduit. dialog.md-sheet-g (guide des tailles) : appui dehors seulement. */
(()=>{
'use strict';
if(window.__mdBoite)return;window.__mdBoite=1;
const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
const reduce=matchMedia('(prefers-reduced-motion: reduce)');
const FOCUS='a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

function panneau(){
  const d=$('#md-sheet');if(!d||!d.showModal)return;
  const c=$('[data-md-sheet-c]',d),x=$('[data-md-sheet-x]',d),grip=$('[data-md-sheet-grip]',d);
  let ouvreur=null,tFerme=0;
  const ouvrir=b=>{
    const t=document.getElementById('md-sh-'+b.dataset.mdSheet);if(!t)return;
    clearTimeout(tFerme);c.replaceChildren(t.content.cloneNode(true));
    const h=$('h2',c);if(h)h.id='md-sheet-t';
    ouvreur=b;d.style.transform='';d.scrollTop=0;
    if(!d.open)d.showModal();
    document.documentElement.classList.add('md-sheet-ouvert');
    requestAnimationFrame(()=>requestAnimationFrame(()=>d.classList.add('is-on')));
    x.focus({preventScroll:true});
  };
  const fermer=()=>{
    if(!d.open)return;
    d.classList.remove('is-on');d.style.transform='';
    document.documentElement.classList.remove('md-sheet-ouvert');
    tFerme=setTimeout(()=>{d.close();if(ouvreur){ouvreur.focus({preventScroll:true});ouvreur=null;}},reduce.matches?0:240);
  };
  document.addEventListener('click',e=>{const b=e.target.closest('[data-md-sheet]');if(b){e.preventDefault();ouvrir(b);}});
  x.addEventListener('click',fermer);
  d.addEventListener('click',e=>{if(e.target===d){const r=d.getBoundingClientRect();if(e.clientY<r.top||e.clientX<r.left||e.clientX>r.right||e.clientY>r.bottom)fermer();}});
  d.addEventListener('cancel',e=>{e.preventDefault();fermer();});
  d.addEventListener('keydown',e=>{if(e.key!=='Tab')return;const f=$$(FOCUS,d);if(!f.length)return;const a=f[0],z=f[f.length-1];
    if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus();}else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus();}});
  let y0=null,dy=0;
  grip.addEventListener('pointerdown',e=>{y0=e.clientY;dy=0;d.classList.add('is-drag');grip.setPointerCapture(e.pointerId);});
  grip.addEventListener('pointermove',e=>{if(y0===null)return;dy=Math.max(0,e.clientY-y0);d.style.transform=`translateY(${dy}px)`;});
  const fin=()=>{if(y0===null)return;y0=null;d.classList.remove('is-drag');if(dy>70)fermer();else d.style.transform='';};
  grip.addEventListener('pointerup',fin);grip.addEventListener('pointercancel',fin);
  $$('dialog.md-sheet-g').forEach(g=>g.addEventListener('click',e=>{if(e.target!==g)return;const r=g.getBoundingClientRect();if(e.clientY<r.top||e.clientX<r.left||e.clientX>r.right||e.clientY>r.bottom)g.close();}));
}

/* Paliers : texte fixe tant que le panier est vide ; ensuite ce qu'il manque. La ligne apparaît dès qu'un article est au panier. */
function paliers(){
  const b=$('[data-md-pall]');if(!b)return;
  const s1=+b.dataset.s1,s2=+b.dataset.s2,p1=b.dataset.p1,p2=b.dataset.p2,t=$('[data-md-pall-t]',b),base=t.innerHTML;
  const eur=c=>(c/100).toLocaleString('fr-FR',{minimumFractionDigits:c%100?2:0,maximumFractionDigits:2})+' €';
  const maj=pn=>{
    if(!(pn>0)){t.innerHTML=base;return;}
    b.hidden=false;
    if(pn<s1)t.textContent=`Encore ${eur(s1-pn)} pour −${p1} %`;
    else if(s2&&pn<s2)t.textContent=`−${p1} % appliqués · encore ${eur(s2-pn)} pour −${p2} %`;
    else t.textContent=`−${s2?p2:p1} % appliqués`;
  };
  maj(+b.dataset.panier||0);
  const relire=()=>fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json()).then(c=>maj(c.items_subtotal_price||0)).catch(()=>{});
  document.addEventListener('shopify:cart:lines-update',()=>setTimeout(relire,300));
}

function start(){panneau();paliers();}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
